/**
 * This is an entrypoint for your main javascript file, when you run gulp watch this file and all
 * it's imports will get bundled into a minified js file and saved in the assets/bundle folder
 * 
 * Info about importing modules https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
 */

import LazyLoad from 'vanilla-lazyload';

/**
 * This function will lazyload every image with the class .lazy
 * info: https://github.com/verlok/lazyload
 */
var lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy',
    class_loaded: 'lazy-loaded'
});

$(document).ready(function(){
    $('.btn-mute').on('click', function () {
        $('.screen').toggleClass('mute');
        $(this).toggleClass('on');
        if ($('#tv').hasClass('mute')) {
            tv.mute();
        } else {
            tv.unMute();
        }
    });
    $('.btn-pause').on('click', function () {
        tv.pauseVideo();
    });    
    $('.navbar-toggler').on('click', function () {
        $('body').toggleClass('nav-open');
        $(this).toggleClass('active');
    });
    
});
$(window).resize(function() {
    if ($(window).width() < 800) {
        $('.filter-toggle').on('click', function () {
            $('.filter-btns button:not(.active)').toggleClass('mob-show');
            $(this).toggleClass('toggle-open');
        });
    }
});